import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUpload = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.9092 20.9988V10.6348",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.90918 14.6349L11.9093 10.6348L15.9095 14.6349",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.8187 17.5453H19.1825C20.1806 17.4505 21.1072 16.9858 21.7801 16.2425C22.453 15.4992 22.8236 14.5312 22.8191 13.5286C22.8145 12.526 22.4351 11.5613 21.7555 10.8242C21.0758 10.0871 20.1451 9.63079 19.1461 9.54503C18.9797 7.87261 18.2386 6.30962 17.0489 5.12242C15.8593 3.93521 14.2948 3.19724 12.622 3.03425C10.9493 2.87126 9.27175 3.29335 7.87531 4.22858C6.47887 5.16381 5.44992 6.55432 4.9638 8.16316C3.85648 8.33866 2.84839 8.90426 2.12151 9.75784C1.39464 10.6114 0.996868 11.6967 1.00002 12.8179C1.00232 14.0095 1.45214 15.1567 2.26037 16.0323C3.06859 16.9078 4.17623 17.4479 5.36382 17.5453H9.00031",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgUpload;
